
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

/** Redirect legacy /moderator/prayers to /submissions */
export default function ModeratorPrayersRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/submissions', { replace: true });
  }, [navigate]);

  return null;
}
